import { useState } from "react";
import "./editorialForms.css";

export default function ThreadsForm({ data, onChange }) {
  const [showQuote, setShowQuote] = useState(data?.isQuote || false);

  const handleQuoteToggle = (e) => {
    const isQuote = e.target.checked;
    setShowQuote(isQuote);
    onChange({ ...data, isQuote });
  };

  return (
    <div className="editorial_form threads_form">
      <div className="editorial_form_section">
        <label>Tipo de Thread</label>
        <select
          value={data?.threadType || "new"}
          onChange={(e) => onChange({ ...data, threadType: e.target.value })}
        >
          <option value="new">Nova Thread</option>
          <option value="reply">Resposta a uma Thread</option>
          <option value="continuation">Continuacao da Thread</option>
        </select>
      </div>

      <div className="editorial_form_section">
        <div className="editorial_form_checkbox">
          <input
            type="checkbox"
            id="isQuote"
            checked={showQuote}
            onChange={handleQuoteToggle}
          />
          <label htmlFor="isQuote">Citar outro post</label>
        </div>
      </div>

      {showQuote && (
        <div className="editorial_form_section">
          <label>Link do post para citar</label>
          <input
            type="text"
            placeholder="Cole o link do post aqui..."
            value={data?.quotedPostUrl || ""}
            onChange={(e) => onChange({ ...data, quotedPostUrl: e.target.value })}
          />
          <span className="editorial_form_hint">
            O post citado aparecera incorporado na sua thread
          </span>
        </div>
      )}

      <div className="editorial_form_section">
        <div className="editorial_form_checkbox">
          <input
            type="checkbox"
            id="allowReplies"
            checked={data?.allowReplies !== false}
            onChange={(e) =>
              onChange({ ...data, allowReplies: e.target.checked })
            }
          />
          <label htmlFor="allowReplies">Permitir respostas</label>
        </div>
        <div className="editorial_form_checkbox">
          <input
            type="checkbox"
            id="allowQuotes"
            checked={data?.allowQuotes !== false}
            onChange={(e) =>
              onChange({ ...data, allowQuotes: e.target.checked })
            }
          />
          <label htmlFor="allowQuotes">Permitir citacoes</label>
        </div>
      </div>

      <div className="editorial_form_tip">
        <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" />
        </svg>
        <span>
          Threads permitem conversas encadeadas. Adicione ate 10 posts em sequencia.
        </span>
      </div>
    </div>
  );
}
